module.exports = __webpack_public_path__ + "static/media/bg-sobre-defa.38bd58d5.jpg";